// extracted by mini-css-extract-plugin
module.exports = {"button":"FormInputButton-button-1SvJA Button-button-2PYOE Link-link-1rgM9","middleButton":"FormInputButton-middleButton-3_ag_"};